// themes/themeOptions.ts
import type { ThemeOptions } from '@mui/material/styles';
import { Poppins } from 'next/font/google';

export const poppins = Poppins({
    subsets: ['latin'],
    weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'], // 需要哪些粗細就列哪些
    display: 'swap',
});

export const POPPINS_FAMILY = `${poppins.style.fontFamily}, sans-serif`;

export const themeOptions: ThemeOptions = {
    palette: {
        primary: { main: '#7A7C81', light: '#CACBCD', dark: '#494A4D' },
        secondary: { main: '#E5673E', light: '#EE9769', dark: '#B75332' },
        background: { default: '#F2F2F2' },
        // 如需型別安全可做 module augmentation；此處維持與你原本 runtime 相容
        text: { primary: '#191A1A' },
    },
    // 先不在這裡塞 fontFamily，改由 Providers 動態帶入
    typography: {
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        body1: { fontWeight: 400 },
        body2: { fontWeight: 400 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                'html, body': {
                    fontWeight: 400,
                    fontSynthesis: 'none',
                },
            },
        },
    },
};
